import { Component, OnInit, ViewChild, ElementRef, HostListener } from "@angular/core";
import { Title } from "@angular/platform-browser";
import { ActivatedRoute, Router } from "@angular/router";
import { TranslocoService } from "@ngneat/transloco";
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import * as QRCode from 'qrcode';
import {
  ConfirmationService,
  MenuItem,
  Message,
  MessageService,
} from "primeng/api";
import {enviroment} from "src/environments/environment";
import { Table } from "primeng/table";
import { Project } from "src/app/model/form/project";
import { Image } from "src/app/model/Image";
import { Vcu } from "src/app/model/form/vcu";
import { LogProject } from "src/app/model/log-project";
import { MapProject } from "src/app/model/map-project";
import { ProjectService } from "../../../service/project.service";
import { Vehicle } from "src/app/model/vehicle";
import { AccountService } from "src/app/service/account.service";
import { VcuService } from "src/app/service/vcu.service";
import { FileService, globalUploadProgress$ } from "src/app/service/file.service";
import { HttpErrorResponse } from "@angular/common/http";
import {
  IMAGE_DEFAULT,
  IMAGE_PUNTO_LIST,
  IMAGE_VOYAGE_LIST,
} from "src/app/model/mockup/image-mockup";
import { VcuAttributes } from "src/app/model/vcu-attributes";
import { Location } from "@angular/common";
import { FamilyService } from "src/app/service/family.service";
import { ModelService } from "src/app/service/model.service";
import { ResellerService } from "src/app/service/reseller.service";
import { firstValueFrom, forkJoin, lastValueFrom, of } from "rxjs";
import { switchMap, map, catchError, take } from 'rxjs/operators';
import { AuthService } from "src/app/service/auth.service";
import { UpdateProjectPutReq } from "src/app/model/request/update-project-put-req";
import { SocialService } from "src/app/service/social.service";

@Component({
  selector: "app-project",
  templateUrl: "./project.component.html",
  styleUrl: "./project.component.css",
})
export class ProjectComponent implements OnInit {
  @ViewChild("fileInputMap", { static: false }) fileInputMap!: ElementRef;
  @ViewChild("fileInputLog", { static: false }) fileInputLog!: ElementRef;

  items: MenuItem[] | undefined;
  logs: LogProject[];
  maps: MapProject[];
  vcus: Vcu[];
  project: Project | null;
  responsiveOptions: any[] | undefined;
  backupLog: LogProject | null = null;
  backupMap: MapProject | null = null;
  projectsEdit: Project[];
  showVcuDialog: boolean = false;
  showEditProjectDialog: boolean = false;
  selectedImage: string | null = null;
  selectedFiles: File[] | null = null;
  showDialogShareLink: boolean = false;

  @ViewChild("dtLog") dtLog: Table | undefined;
  @ViewChild("dtMap") dtMap: Table | undefined;

  loadingLog: boolean = false;
  loadingMap: boolean = false;
  loadingProject: boolean = false;

  vehicle = new Vehicle();
  token: string | null = "";
  userID: string = "";
  userNickname: string = "";
  userName: string = "";
  projectID: string = "";
  projectName: string = "";

  vcuUnlink: Vcu | null = null;
  showDialogUnlink: boolean = false;
  projectUnlinkInvalid: string = "";
  unlinkVcuBtnLoading: boolean = false;
  reasonUnlinkVcu: string = "";
  messages: Message[] = [];
  dashboardUrl: string = "/my-garage";

  familyOptions: any[] = [];
  modelOptions: any[] = [];
  resellerOptions: any[] = [];

  isProjectShared: boolean = false;
  userOwnerID: string = "";
  labelUrl: string = "www.hml.fueltech.cloud/project/public/";
  sharingProjectType: number = 0;
  classPublicUrl: string = "";

  projectsPerPage = 2;
  currentIndex = 0;
  currentIndexShared = 0;

  visibleThumbs: Image[] = [];
  thumbStart = 0;
  visibleCount = 5;

  progressState: string = "";
  progressValue: number = 0;
  uploadedFiles: any[] = [];
  keyFiles: any[] = [];
  loadingSaveTask: boolean = false;
  disableSaveTask: boolean = false;
  displayUploadLogMap: boolean = false
  typeFileSelected: string = "";

  displayImage: boolean = false
  imageSelectedUrl: string = ""
  downloadingPDF: boolean = false;
  qrCodeDataUrl: string = '';

  constructor(
    private translocoService: TranslocoService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private confirmationService: ConfirmationService,
    private titleService: Title,
    private projectService: ProjectService,
    private accountService: AccountService,
    private messageService: MessageService,
    private vcuService: VcuService,
    private fileService: FileService,
    private location: Location,
    private familyService: FamilyService,
    private modelService: ModelService,
    private authService: AuthService,
    private resellerService: ResellerService,
    private socialService: SocialService
  ) {
    this.showVcuDialog = false;
    this.project = null;
    this.vcus = [];
    this.logs = [];
    this.maps = [];
    this.projectsEdit = [];

    this.loadingLog = false;
    this.loadingMap = false;
  }

  ngOnInit(): void {
    globalUploadProgress$.subscribe((percent) => {
      this.progressValue = percent;
    });
    
    this.setTitle();
    this.token = sessionStorage.getItem("token");
    this.changeLanguage();
    this.messageService.clear();
    window.scrollTo({ top: 0, behavior: "smooth" });
    this.initResponsiveOptions();

    // Mostrar loading imediatamente
    this.loadingProject = true;

    // Obter projectID da rota
    this.activatedRoute.params.subscribe((params) => {
      this.projectID = params["id"];
      this.loadProjectDataOptimized();
    });
  }

  /**
   * Carrega dados do projeto de forma otimizada com loading imediato
   */
  private loadProjectDataOptimized(): void {
    // Buscar userID do cache (AuthService já tem)
    this.authService.getUserData().pipe(
      switchMap((userData) => {
        if (!userData) {
          this.router.navigate(['/login']);
          throw new Error('Usuário não autenticado');
        }

        this.userID = userData.userID;
        
        // Configurar contexto VCU Service
        this.vcuService.setUserID(this.userID);
        this.vcuService.setProjectID(this.projectID);

        // Carregar TUDO em paralelo - mantém otimização
        return forkJoin({
          projectData: this.projectService.getProject(this.userID, this.projectID),
          families: this.familyService.getAllFamily(),
          models: this.modelService.getAllModel(),
          resellers: this.resellerService.getAllReseller()
        }).pipe(
          switchMap((result) => {
            // Processar opções
            this.familyOptions = FamilyService.toItemList(result.families);
            this.modelOptions = ModelService.toItemList(result.models);
            this.resellerOptions = ResellerService.toItemList(result.resellers);

            // Se tem projeto, buscar dados do dono em paralelo
            if (result.projectData) {
              return this.accountService.getAccount(result.projectData.userID).pipe(
                map((ownerData) => ({
                  projectData: result.projectData,
                  ownerData
                })),
                catchError(() => of({
                  projectData: result.projectData,
                  ownerData: null
                }))
              );
            }
            
            throw new Error('Projeto não encontrado');
          })
        );
      }),
      catchError((error) => {
        console.error('Erro ao carregar projeto:', error);
        this.loadingProject = false;
        this.router.navigate([this.dashboardUrl]);
        return of(null);
      })
    ).subscribe((result) => {
      if (result && result.projectData) {
        this.processProjectData(result.projectData, result.ownerData);
        this.loadingProject = false;
      }
    });
  }

  /**
   * Processa dados do projeto carregados
   */
  private processProjectData(dataProject: any, ownerData: any | null): void {
    this.processVCUDescriptions(dataProject.vcus || []);
    this.reorderPrimaryPhoto(dataProject);

    // Dados do dono
    if (ownerData) {
      this.userName = ownerData.name;
      this.userNickname = ownerData.nickname;
      this.projectName = dataProject.projectName?.toLowerCase();
    }

    this.project = ProjectService.toProject(dataProject);
    this.vcus = this.project?.vcus ?? [];
    this.maps = this.project?.maps ?? [];
    this.logs = this.project?.logs ?? [];

    setTimeout(() => this.setTitle(dataProject.projectName), 0);
    this.setImageDefault();
    this.isProjectShared = dataProject.isSharing;
    this.userOwnerID = this.project.userID;
    this.loadAuthorAvatar(this.project.userID);

    if (this.project?.images?.length) {
      this.selectedImage = this.project.images[0].href ?? null;
      this.updateVisibleThumbs();
    }
  }

private initResponsiveOptions(): void {
  this.responsiveOptions = [
    { breakpoint: "1430px", numVisible: 3, numScroll: 1 },
    { breakpoint: "1260px", numVisible: 2, numScroll: 1 },
    { breakpoint: "870px", numVisible: 1, numScroll: 1 },
  ];
}

/** Link público da APLICAÇÃO para compartilhar (host da app, não o da API). */
get shareUrl(): string {
  return this.projectID ? enviroment.BASE_URL + this.feedPath : "";
}

/** Caminho do feed público do projeto — usado no QR/PDF (aponta para /feed, não /project/public). */
get feedPath(): string {
  return `/feed/project/${this.projectID}`;
}

/** sharingProjectType.id vem tipado como number|string no model — normaliza para o modal (@Input number). */
get sharingTypeIdForShare(): number {
  return Number(this.project?.sharingProjectType?.id) || 0;
}

/** Reflete no card a mudança de visibilidade feita dentro do modal (sem reload). */
onSharingTypeChanged(typeId: number): void {
  if (this.project?.sharingProjectType) {
    this.project.sharingProjectType.id = typeId;
  }
}

copyShareLink(): void {
  if (this.projectID) {
    const url = this.shareUrl;
    navigator.clipboard.writeText(url).then(() => {
      this.showMessage("success", this.translocoService.translate('messages.info.copied'), this.translocoService.translate('messages.success.linkCopied'));
    });
  }
}


/**
   * Atualiza dados do projeto (chamado após edições)
   * Usa carregamento paralelo otimizado
   */
  refreshProject(): void {
    this.loadingProject = true;
    
    forkJoin({
      projectData: this.projectService.getProject(this.userID, this.projectID),
      ownerData: this.projectService.getProject(this.userID, this.projectID).pipe(
        switchMap((project) => {
          if (project) {
            return this.accountService.getAccount(project.userID);
          }
          return of(null);
        })
      )
    }).subscribe({
      next: ({ projectData, ownerData }) => {
        if (projectData) {
          this.processProjectData(projectData, ownerData);
        }
        this.loadingProject = false;
      },
      error: (error) => {
        console.error('Erro ao atualizar projeto:', error);
        this.loadingProject = false;
      }
    });
  }

private processVCUDescriptions(vcus: any[]): void {
    for (let vcu of vcus) {
      if (vcu.familyID) {
        const family = this.familyOptions.find((f) => f.id === vcu.familyID);
        vcu.familyDescription = family?.name;
      }

      const modelId = vcu.attributes?.model;
      if (modelId) {
        vcu.modelID = modelId.toString();
        const model = this.modelOptions.find((m) => m.id === modelId);
        vcu.modelDescription = model?.name;
      }

      if (vcu.resellerID) {
        const reseller = this.resellerOptions.find(
          (r) => r.id === vcu.resellerID
        );
        vcu.resellerDescription = reseller?.name;
      }
    }
  }

private reorderPrimaryPhoto(dataProject: any): void {
  const attrs = dataProject.attributes;
  if (attrs?.photo && attrs.primaryImage) {
    let photoArray = attrs.photo.split(",");
    const primaryIndex = photoArray.indexOf(attrs.primaryImage);
    if (primaryIndex !== -1) {
      photoArray.splice(primaryIndex, 1);
      photoArray.unshift(attrs.primaryImage);
    }
    attrs.photo = photoArray.join(",");
  }
}

  async editProject() {
    // Garantir que o dialog está fechado antes de abrir novamente
    this.showEditProjectDialog = false;
    setTimeout(() => {
      this.showEditProjectDialog = true;
    }, 0);
  }

  updateVcuDialog() {
    this.showVcuDialog = false;
    this.refreshProject();
  }
  closeProjectDialog() {
    // Apenas fecha — NÃO recarrega. O reload só acontece quando o projeto é salvo (onProjectSaved).
    this.showEditProjectDialog = false;
  }

  /** Chamado pelo (saved) do modal — recarrega só quando houve alteração salva. */
  onProjectSaved() {
    this.showEditProjectDialog = false;
    this.refreshProject();
  }

  onRowEditInitLog(log: LogProject) {
    this.backupLog = { ...log };
  }

  onRowEditSaveLog(log: LogProject) {
    //TODO chamar backend e atualizar o log editado
  }

  onRowEditCancelLog(index: number) {
    if (this.backupLog) this.logs[index] = { ...this.backupLog };
  }

  onRowRemoveLog(event: Event, index: number) {
    this.translocoService
      .selectTranslateObject("project.detail.tableLog.delete")
      .subscribe((value) =>
        this.confirmationService.confirm({
          target: event.target as EventTarget,
          message: `${value.message} ${this.logs[index].name} ?`,
          header: value.header,
          icon: "pi pi-info-circle",
          acceptButtonStyleClass: "p-button-danger",
          rejectButtonStyleClass: "p-button-text",
          acceptLabel: value.yes,
          rejectLabel: value.no,
          acceptIcon: "none",
          rejectIcon: "none",
          accept: () => {
            const id = this.logs[index].id;
            this.projectService
              .DeleteProjectLog(this.userID, this.projectID, id)
              .subscribe({
                next: () => {
                  const i = this.logs[index]?.id === id ? index : this.logs.findIndex((l) => l.id === id);
                  if (i >= 0) this.logs.splice(i, 1);
                },
                error: (err) => this.notifyDeleteError(err),
              });
          },
          reject: () => {},
        })
      )
      .unsubscribe();
  }

  onRowEditInitMap(map: MapProject) {
    this.backupMap = { ...map };
  }

  onRowEditSaveMap(map: MapProject) {
    //TODO chamar backend e atualizar o Map editado
  }

  onRowEditCancelMap(index: number) {
    if (this.backupMap) this.maps[index] = { ...this.backupMap };
  }

  onRowRemoveMap(event: Event, index: number) {
    this.translocoService
      .selectTranslateObject("project.detail.tableMap.delete")
      .subscribe((value) =>
        this.confirmationService.confirm({
          target: event.target as EventTarget,
          message: `${value.message} ${this.maps[index].name} ?`,
          header: value.header,
          icon: "pi pi-info-circle",
          acceptButtonStyleClass: "p-button-danger",
          rejectButtonStyleClass: "p-button-text",
          acceptLabel: value.yes,
          rejectLabel: value.no,
          acceptIcon: "none",
          rejectIcon: "none",
          accept: () => {
            const id = this.maps[index].id;
            this.projectService
              .DeleteProjectMap(this.userID, this.projectID, id)
              .subscribe({
                next: () => {
                  const i = this.maps[index]?.id === id ? index : this.maps.findIndex((m) => m.id === id);
                  if (i >= 0) this.maps.splice(i, 1);
                },
                error: (err) => this.notifyDeleteError(err),
              });
          },
          reject: () => {},
        })
      )
      .unsubscribe();
  }

  private notifyDeleteError(err: unknown): void {
    const status = err instanceof HttpErrorResponse ? err.status : 0;
    const key =
      status === 400 ? 'common.deleteErrors.badRequest'
      : status === 403 ? 'common.deleteErrors.forbidden'
      : status === 404 ? 'common.deleteErrors.notFound'
      : 'common.deleteErrors.generic';
    const severity = status === 404 ? 'warn' : 'error';

    this.translocoService
      .selectTranslate(key)
      .subscribe((msg) =>
        this.messageService.add({ key: 'toastProject', severity, summary: msg })
      )
      .unsubscribe();
  }

  /** Foto do dono do projeto — a mesma de "Meu Perfil".
   *
   *  O avatar ao lado de "por <nome>" era a PRIMEIRA FOTO DO PROJETO, entao a
   *  foto do carro passava por retrato do autor. */
  authorAvatarUrl: string | null = null;

  private loadAuthorAvatar(userId: string): void {
    if (!userId) return;
    this.socialService.getProfile(userId).subscribe({
      next: (perfil) => (this.authorAvatarUrl = perfil.avatarUrl ?? null),
      error: () => (this.authorAvatarUrl = null),   // sem foto, ficam as iniciais
    });
  }

  /** Iniciais do dono, usadas quando nao ha foto — mesmo fallback do header. */
  get authorInitials(): string {
    const nome = (this.userName || "").trim();
    if (!nome) return "?";
    const partes = nome.split(/\s+/);
    const primeira = partes[0][0] || "";
    const ultima = partes.length > 1 ? partes[partes.length - 1][0] : "";
    return (primeira + ultima).toUpperCase();
  }

  /** Marca o projeto como PADRAO — mesmo caminho ja usado no card-project:
   *  confirma e manda `default = true`.
   *
   *  A estrela existia no template sem nenhum (click): botao morto. E ela nunca
   *  foi "favoritar" — a i18n da acao e `project.card.default` ("Projeto
   *  Padrao"), por isso o tooltip agora diz o que o botao faz. */
  setAsDefaultProject(): void {
    if (!this.project?.id || this.project.favorite) return;  // a API so liga

    // take(1) em vez de subscribe().unsubscribe(): se a traducao ainda nao
    // estiver carregada a emissao e assincrona, e o unsubscribe imediato
    // deixaria o botao sem fazer nada de novo.
    this.translocoService
      .selectTranslateObject("project.card.default")
      .pipe(take(1))
      .subscribe((texto: any) =>
        this.confirmationService.confirm({
          message: texto.message,
          header: texto.header,
          icon: "pi pi-info-circle",
          acceptLabel: texto.yes,
          rejectLabel: texto.no,
          acceptIcon: "none",
          rejectIcon: "none",
          accept: () => {
            const req = new UpdateProjectPutReq();
            req.default = true;
            this.projectService
              .updateProject(this.userID, this.project!.id!, req)
              .subscribe({
                next: () => {
                  this.project!.favorite = true;
                  this.messageService.add({
                    key: "toastProject",
                    severity: "success",
                    summary: texto.header,
                    detail: texto.confirm,
                  });
                },
                error: () =>
                  this.messageService.add({
                    key: "toastProject",
                    severity: "error",
                    summary: texto.header,
                    detail: texto.error,
                  }),
              });
          },
        })
      );
  }

  applyFilterGlobalLog(event: Event, mode: string) {
  const input = event.target as HTMLInputElement;
  this.dtLog?.filterGlobal(input.value, mode);
}

applyFilterGlobalMap(event: Event, mode: string) {
  const input = event.target as HTMLInputElement;
  this.dtMap?.filterGlobal(input.value, mode);
}

  pageVCU() {}

  pageProject() {}

  setTitle(title?: string) {
    if (title) {
      this.titleService.setTitle("FT Pilot - " + title);
    } else {
      this.translocoService
        .selectTranslate("title.project")
        .subscribe((value) => this.titleService.setTitle(value));
    }
  }

  setImageDefault() {
    if (this.project && this.project.images.length < 5) {
      for (let i = this.project.images.length; i < 5; i++) {
        this.project.images.push(IMAGE_DEFAULT);
      }
    }
  }

  public changeLanguage(languageCode?: string | null): void {
    if (!languageCode || languageCode === null)
      languageCode = sessionStorage.getItem("language");
    if (languageCode && languageCode !== null)
      this.translocoService.setActiveLang(languageCode);
  }

  disableProject() {
    this.translocoService
      .selectTranslateObject("project.detail.delete")
      .subscribe((value) =>
        this.confirmationService.confirm({
          message: `${value.message.lineOne} <br> ${value.message.lineTwo}`,
          header: value.header,
          icon: "pi pi-info-circle",
          acceptButtonStyleClass: "p-button-danger",
          rejectButtonStyleClass: "p-button-text",
          acceptLabel: value.yes,
          rejectLabel: value.no,
          acceptIcon: "none",
          rejectIcon: "none",
          accept: () => {
            this.loadingProject = true
            this.projectService
              .disableProject(this.userID, this.projectID)
              .subscribe({
                next: (_) => {
                  this.messageService.clear();
                  this.messageService.add({
                    key: "toastProject",
                    severity: "success",
                    summary: value.sucess.header,
                    detail: value.sucess.message,
                  });
                  this.loadingProject = false
                  this.router.navigate([this.dashboardUrl]);
                },
                error: (_) => {
                  this.loadingProject = false
                },
              });
          },
          reject: () => {
          },
        })
      )
      .unsubscribe();
  }

  async onSelectFile(event: Event) {
    const input = event.target as HTMLInputElement;
    if (!input.files?.length) return;

    this.selectedFiles = Array.from(input.files);
    input.value = '';

    for (const file of this.selectedFiles) {
      try {
        await this.uploadFileSequentially(file);

        this.progressValue = 0;
        const alreadyExists = this.uploadedFiles.some(
          (f) => f.name === file.name && f.size === file.size
        );

        if (!alreadyExists) {
          this.uploadedFiles.push({
            name: file.name,
            size: file.size,
            href: URL.createObjectURL(file),
            file: file,
          });
        }
      } catch (error) {
        this.showMessage(
          "error",
          this.translocoService.translate('common.labels.warning'),
          this.translocoService.translate('messages.error.fileUploadError', { fileName: file.name })
        );
      }
    }
  }
  closeModal() {
    this.displayUploadLogMap = false
    this.uploadedFiles = []
    this.keyFiles = []
    this.typeFileSelected = ""
    this.selectedFiles = null;

  }

  removeFile(image: any) {
    this.uploadedFiles = this.uploadedFiles.filter((f) => f !== image);
    this.keyFiles = this.keyFiles.filter((f) => f.name !== image.name);
    if(this.uploadedFiles == null) {
      this.disableSaveTask = true
    }
  }

  uploadFileSequentially(file: File): Promise<void> {
    return new Promise((resolve, reject) => {
      this.progressState = "start";
      this.loadingSaveTask = true;
      this.disableSaveTask = true;

      const fileEntry = {
        name: file.name,
        size: file.size,
        file: file,
      };

      this.uploadedFiles.push(fileEntry);

      this.fileService
        .UploadFiles(
          file,
          this.typeFileSelected,
          this.userID,
          this.projectID,
          ""
        )
        .then((response) => {
          if (response && 'status' in response && response.status === 200) {
            this.keyFiles.push({
              key: crypto.randomUUID(),
              name: file.name,
              size: file.size,
              persisted: false,
            });

            this.loadingSaveTask = false;
            this.disableSaveTask = false;
            this.progressState = "complete";
            this.addUploadedFileToList(response, file, this.typeFileSelected, this.projectID);
            resolve();
          } else if (response && "status" in response && response.status === 403) {
              // Upload falhou → tira da lista para NÃO persistir (senão vira registro no banco sem objeto no bucket).
              this.uploadedFiles = this.uploadedFiles.filter((f) => f !== fileEntry);
              this.showMessage('error', this.translocoService.translate('messages.error.uploadFailed'), this.translocoService.translate('messages.error.maxStorageReached'))
              this.loadingSaveTask = false;
              reject();
          } else {
              this.uploadedFiles = this.uploadedFiles.filter((f) => f !== fileEntry);
              this.showMessage('error', this.translocoService.translate('common.labels.error'), this.translocoService.translate('messages.error.uploadFailed'))
              this.loadingSaveTask = false;
              reject();
            }
        })
        .catch(() => {
          this.uploadedFiles = this.uploadedFiles.filter((f) => f !== fileEntry);
          reject();
        });
    });
  }

  persistLogMap() {
    const files = [...this.uploadedFiles];
    if (files.length === 0) return;

    this.loadingSaveTask = true;
    this.disableSaveTask = true;

    let done = 0;
    let failed = 0;

    // Só reporta sucesso quando TODOS os persists retornam sucesso — evita dizer
    // "salvo" quando o registro não foi realmente criado no banco (arquivo some no download/análise).
    const finalize = () => {
      if (done + failed < files.length) return;
      this.loadingSaveTask = false;
      this.disableSaveTask = false;
      this.uploadedFiles = [];
      if (failed === 0) {
        this.showMessage(
          "success",
          this.translocoService.translate('messages.success.title'),
          this.translocoService.translate('messages.success.uploadSuccess')
        );
      } else {
        this.showMessage(
          "error",
          this.translocoService.translate('common.labels.error'),
          this.translocoService.translate('messages.error.uploadFailed')
        );
      }
      this.closeModal();
    };

    files.forEach((fileName) => {
      this.fileService
        .persistFileUnified(
          this.userID,
          this.typeFileSelected as 'map' | 'log',
          { file: fileName.name, projectID: this.projectID }
        )
        .subscribe({
          next: (response) => {
            if (response.status >= 200 && response.status < 300) {
              done++;
            } else {
              failed++;
            }
            finalize();
          },
          error: () => {
            failed++;
            finalize();
          },
        });
    });
  }

  triggerFileUpload(type: string) {
    this.typeFileSelected = type;
    this.displayUploadLogMap = true
  }

  handleFileInput(event: Event, type: string) {
    const input = event.target as HTMLInputElement;
    if (!input.files || input.files.length === 0) return;

    const file = input.files[0];
    input.value = ""; // permite re-selecionar o mesmo arquivo

    // Unificado com o fluxo robusto do modal: sobe o binário com checagem de
    // status (+rollback da lista em falha) e só persiste/anuncia sucesso após o
    // 2xx do complete + persist. Elimina o "falso sucesso" que adicionava o item
    // à lista logo após o `start`, sem confirmar o upload nem o registro.
    this.typeFileSelected = type;
    this.uploadFileSequentially(file)
      .then(() => this.persistLogMap())
      .catch(() => {
        // uploadFileSequentially já removeu o item da lista e exibiu o erro.
      });
  }

  getCurrentDate(): string {
  const now = new Date();

  const pad = (n: number) => n.toString().padStart(2, '0');

  const day = pad(now.getDate());
  const month = pad(now.getMonth() + 1);
  const year = now.getFullYear();

  return `${day}-${month}-${year}`;
}

  addUploadedFileToList(
  response: any,
  file: File,
  type: string,
  projectID: string
) {
  const dateStr = response.body?.date ?? response.createdDate;
  const formattedDate = this.getCurrentDate()

  const newFile = {
    id: response.id,
    name: file.name,
    project: projectID,
    tags: [],
    date: formattedDate,
  };

  if (type === 'map') {
    this.maps.push(newFile);
  } else if (type === 'log') {
    this.logs.push(newFile);
  }
}

private formatDate(dateStr: string | undefined): string {
  if (!dateStr) return '';

  const dateObj = new Date(dateStr);
  const day = String(dateObj.getDate()).padStart(2, '0');
  const month = String(dateObj.getMonth() + 1).padStart(2, '0');
  const year = dateObj.getFullYear();
  return `${day}-${month}-${year}`;
}

  onRowDownload(type: string, index: number): void {
    const fileName = this.getFileName(type, index);
    const fileID = this.getFileID(type, index);
    const chunkSize = 10483712; // 10MB
    const startRange = 0;
    const endRange = chunkSize;

    this.fileService
      .downloadFile(
        this.userID,
        this.projectID,
        type,
        fileName,
        startRange,
        endRange,
        fileID
      )
      .subscribe({
        next: async (response) => {
          const contentRange = response.headers.get("Content-Range");
          const totalSize = contentRange
            ? parseInt(contentRange.split("/")[1], 10)
            : 0;

          const blobs: Blob[] = [response.body as Blob];

          if (totalSize > chunkSize) {
            const totalChunks = Math.ceil(totalSize / chunkSize);
            const promises: Promise<any>[] = [];

            for (let i = 1; i < totalChunks; i++) {
              const start = i * chunkSize + 1;
              const end = (i + 1) * chunkSize;
              promises.push(
                this.fileService
                  .downloadFile(
                    this.userID,
                    this.projectID,
                    type,
                    fileName,
                    start,
                    end,
                    fileID
                  )
                  .toPromise()
              );
            }

            try {
              const responses = await Promise.all(promises);
              responses.forEach((resp) => {
                if (resp?.body) {
                  blobs.push(resp.body as Blob);
                }
              });

              this.downloadBlob(new Blob(blobs), fileName);
            } catch (error) {
              console.error("Erro ao baixar arquivos em partes:", error);
            }
          } else {
            this.downloadBlob(response.body as Blob, fileName);
          }
        },
        error: (err) => {
          console.error("Erro ao baixar o arquivo inicial:", err);
        },
      });
  }

private getFileName(type: string, index: number): string {
  if (type === 'map') return this.maps[index].name;
  if (type === 'log') return this.logs[index].name;
  return 'arquivo_desconhecido';
}

private getFileID(type: string, index: number): string {
  if (type === 'map') return this.maps[index].id;
  if (type === 'log') return this.logs[index].id;
  return 'id_desconhecido';
}

private downloadBlob(blob: Blob, fileName: string): void {
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = fileName;
  link.click();
  window.URL.revokeObjectURL(url);
}


  dialogUnlink(index: number) {
    this.vcuUnlink = this.vcus[index];
    this.vcuService.setVcuID(this.vcuUnlink.id);
    this.projectUnlinkInvalid = "";
    this.messages = [];
    this.showDialogUnlink = true;
  }

  unlinkVCU() {
    if (this.vcuUnlink) {
      if (!this.vcuUnlink.vcuAttributes) {
        this.vcuUnlink.vcuAttributes = new VcuAttributes();
      }
      this.unlinkVcuBtnLoading = true;
      this.vcuUnlink.vcuAttributes.reasonUnlink = this.reasonUnlinkVcu;
      this.vcuService.updateVcu(this.vcuUnlink).subscribe((updated) => {
        this.vcuService.unlinkVcuInProject().subscribe({
          next: (_) => {
            this.messages = [];
            this.messageService.clear();
            this.translocoService
              .selectTranslateObject("vcu.detail.unlinkVcu")
              .subscribe((value) => {
                this.messageService.add({
                  key: "toastProject",
                  severity: "success",
                  summary: value.header,
                  detail: value.msgSuccess,
                });
              })
              .unsubscribe();
            this.refreshProject();
            this.unlinkVcuBtnLoading = false;
            this.showDialogUnlink = false;
          },
          error: (_) => {
            this.messages = [];
            this.unlinkVcuBtnLoading = false;
            this.translocoService
              .selectTranslate("errorConection")
              .subscribe(
                (value) =>
                  (this.messages = [{ severity: "error", summary: value }])
              )
              .unsubscribe();
          },
        });
      });
    } else {
      this.projectUnlinkInvalid = "ng-dirty ng-invalid";
      this.translocoService
        .selectTranslate("inputRequired")
        .subscribe(
          (value) => (this.messages = [{ severity: "error", summary: value }])
        )
        .unsubscribe();
    }
  }

  selectImage(imageHref: string) {
    this.selectedImage = imageHref;
  }

  prevImage() {
    if (!this.project?.images) return;
    const currentIndex = this.project.images.findIndex(
      (img) => img.href === this.selectedImage
    );
    const newIndex =
      currentIndex > 0 ? currentIndex - 1 : this.project.images.length - 1;
    this.selectedImage = this.project.images[newIndex].href ?? null;
  }

  nextImage() {
    if (!this.project?.images) return;
    const currentIndex = this.project.images.findIndex(
      (img) => img.href === this.selectedImage
    );
    const newIndex = (currentIndex + 1) % this.project.images.length;
    this.selectedImage = this.project.images[newIndex].href ?? null;
  }

  updateVisibleThumbs() {
    if (this.project?.images) {
      this.visibleThumbs = this.project?.images.slice(
        this.thumbStart,
        this.thumbStart + this.visibleCount
      );
    }
  }

  prevThumbs() {
    if (this.thumbStart > 0) {
      this.thumbStart -= this.visibleCount;
      if (this.thumbStart < 0) this.thumbStart = 0;
      this.updateVisibleThumbs();
    }
  }

  nextThumbs() {
    if (
      this.project?.images &&
      this.thumbStart + this.visibleCount < this.project.images.length
    ) {
      this.thumbStart += this.visibleCount;
      this.updateVisibleThumbs();
    }
  }

  get totalPages(): number {
    const projects = this.project?.vcus || [];
    return Math.ceil(projects.length / this.projectsPerPage);
  }

  nextSlide() {
    if (this.currentIndex < this.totalPages - 1) {
      this.currentIndex++;
    }
  }

  prevSlide() {
    if (this.currentIndex > 0) {
      this.currentIndex--;
    }
  }

private showMessage(
  severity: 'success' | 'error' | 'info' | 'warn',
  summary: string,
  detail: string
): void {
  this.messageService.clear();
  this.messageService.add({
    key: 'toastProject',
    severity,
    summary,
    detail,
  });
}


  lightboxIndex = 0;
  private touchStartX = 0;
  private touchEndX = 0;

  @HostListener('document:keydown', ['$event'])
  handleKeydown(event: KeyboardEvent) {
    if (!this.displayImage) return;
    if (event.key === 'Escape') {
      this.closeImage();
    } else if (event.key === 'ArrowLeft') {
      this.lightboxPrev(new MouseEvent('click'));
    } else if (event.key === 'ArrowRight') {
      this.lightboxNext(new MouseEvent('click'));
    }
  }

  openImage(image: string) {
    this.imageSelectedUrl = image;
    this.lightboxIndex = this.project?.images?.findIndex(img => img.href === image) ?? 0;
    if (this.lightboxIndex < 0) this.lightboxIndex = 0;
    this.displayImage = true;
    document.body.style.overflow = 'hidden';
  }

  closeImage() {
    this.displayImage = false;
    document.body.style.overflow = '';
  }

  closeLightbox(event: MouseEvent) {
    if ((event.target as HTMLElement).classList.contains('lightbox-overlay')) {
      this.closeImage();
    }
  }

  lightboxPrev(event: MouseEvent) {
    event.stopPropagation();
    if (!this.project?.images) return;
    this.lightboxIndex = this.lightboxIndex > 0
      ? this.lightboxIndex - 1
      : this.project.images.length - 1;
    this.imageSelectedUrl = this.project.images[this.lightboxIndex].href ?? '';
  }

  lightboxNext(event: MouseEvent) {
    event.stopPropagation();
    if (!this.project?.images) return;
    this.lightboxIndex = (this.lightboxIndex + 1) % this.project.images.length;
    this.imageSelectedUrl = this.project.images[this.lightboxIndex].href ?? '';
  }

  lightboxGoTo(index: number) {
    if (!this.project?.images) return;
    this.lightboxIndex = index;
    this.imageSelectedUrl = this.project.images[index].href ?? '';
  }

  onTouchStart(event: TouchEvent) {
    this.touchStartX = event.changedTouches[0].screenX;
  }

  onTouchEnd(event: TouchEvent) {
    this.touchEndX = event.changedTouches[0].screenX;
    const diff = this.touchStartX - this.touchEndX;
    if (Math.abs(diff) > 50) {
      if (diff > 0) {
        this.lightboxNext(new MouseEvent('click'));
      } else {
        this.lightboxPrev(new MouseEvent('click'));
      }
    }
  }

  async downloadProjectCardAsPDF(): Promise<void> {
    this.downloadingPDF = true;

    try {
      const fullPublicUrl = `${window.location.origin}${this.feedPath}`;
      this.qrCodeDataUrl = await QRCode.toDataURL(fullPublicUrl, {
        width: 300,
        margin: 2,
        color: { dark: '#000000', light: '#FFFFFF' }
      });

      await new Promise(resolve => setTimeout(resolve, 200));

      const cardElement = document.getElementById('print-card-content');
      if (!cardElement) {
        throw new Error('Card element not found');
      }

      const canvas = await html2canvas(cardElement, {
        scale: 3,
        useCORS: true,
        backgroundColor: '#ffffff',
        logging: false
      });

      // A pagina do PDF tem exatamente o tamanho do card: sem margem branca em
      // volta, as faixas vermelhas encostam na borda da folha.
      const imgWidth = 210;
      const imgHeight = (canvas.height * imgWidth) / canvas.width;

      const pdf = new jsPDF({
        orientation: 'portrait',
        unit: 'mm',
        format: [imgWidth, imgHeight]
      });

      const imgData = canvas.toDataURL('image/png');
      pdf.addImage(imgData, 'PNG', 0, 0, imgWidth, imgHeight);

      const fileName = `projeto-${this.project?.name || 'card'}.pdf`;
      pdf.save(fileName);

      this.showMessage('success',
        this.translocoService.translate('messages.success.title'),
        this.translocoService.translate('messages.success.cardDownloaded')
      );
    } catch (error) {
      this.showMessage('error',
        this.translocoService.translate('messages.warning.title'),
        this.translocoService.translate('messages.error.pdfGenerateError')
      );
    } finally {
      this.downloadingPDF = false;
    }
  }

}
